import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ApiHelper } from "../../utils/ApiHelper";
import { UPLOAD_COMPANY_LOGO, CREATE_INVITE, SEND_INVITE } from "../../lib/API_KEYS";

const InviteMemberModal = ({ isOpen, onClose, subRoles }) => {
  const [formData, setFormData] = useState({
    profilePic: null,
    name: "",
    email: "",
    role: "",
    country: "",
    city: "",
    postcode: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, files, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleRemoveProfilePic = () => {
    setFormData((prev) => ({ ...prev, profilePic: null }));
  };

  const validateForm = () => {
    const { name, email, role, country, city, postcode } = formData;
    if (!name || !email || !role || !country || !city || !postcode) {
      toast.error("Please fill all required fields!");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      let profilePicUrl = "";

      if (formData.profilePic) {
        const uploadRes = await new ApiHelper().FetchFromServer(
          ...UPLOAD_COMPANY_LOGO,
          undefined,
          { fileName: formData.profilePic.name, fileType: formData.profilePic.type, fileSize: formData.profilePic.size },
        );

        if (uploadRes.data?.isError || !uploadRes.data?.signedRequest) {
          console.error("Failed to get upload URL");
          return;
        }

        await fetch(uploadRes.data.signedRequest, {
          method: "PUT", body: formData.profilePic, headers: {
            "Content-Type": formData.profilePic.type,
          },
        });
        profilePicUrl = uploadRes.data.fileUrl;
      }

      const payload = {
        profilePic: profilePicUrl || null,
        country: formData.country,
        city: formData.city,
        name: formData.name,
        postcode: formData.postcode,
        email: formData.email,
        role: formData.role,
        status: "pending",
      };

      const inviteResp = await new ApiHelper().FetchFromServer(
        ...CREATE_INVITE,
        undefined,
        payload,
      );
      console.log("✉️ Invite created:", inviteResp.data);


      await new ApiHelper().FetchFromServer(
        ...SEND_INVITE,
        undefined,
        { email: formData.email, inviteId: inviteResp.data._id },
      );

      toast.success("Member invited successfully! Verification email sent.", {
        onClose: () => onClose(),
        autoClose: 3000,
      });

      setFormData({
        profilePic: null,
        name: "",
        email: "",
        role: "",
        country: "",
        city: "",
        postcode: "",
      });
    } catch (error) {
      console.error("Error:", error);
      if (error.response?.status === 409) {
        toast.warning("User already exists in Cognito");
      } else {
        toast.error("Failed to invite member");
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div style={styles.overlay} onClick={onClose}>
        <div
          style={{ ...styles.modal, ...styles.fadeIn }}
          onClick={(e) => e.stopPropagation()}
        >
          <h3 style={styles.header}>Invite New Member</h3>
          <hr />

          <form style={styles.form} onSubmit={handleSubmit}>

            <div style={styles.formRow}>
              <label style={styles.label}>Profile Picture</label>
              <div style={styles.photoBox}>
                <span style={styles.photoText}>150×150px JPEG, PNG Image</span>
                <div
                  style={styles.photoContainer}
                  onClick={() =>
                    document.getElementById("profilePicInput").click()
                  }
                >
                  {formData.profilePic ? (
                    <img
                      src={URL.createObjectURL(formData.profilePic)}
                      alt="profile"
                      style={styles.photoCircle}
                    />
                  ) : (
                    <div style={styles.photoCircle}></div>
                  )}

                  {formData.profilePic && (
                    <span
                      style={styles.removeIcon}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveProfilePic();
                      }}
                    >
                      ×
                    </span>
                  )}

                  <input
                    id="profilePicInput"
                    type="file"
                    name="profilePic"
                    accept="image/*"
                    onChange={handleChange}
                    style={{ display: "none" }}
                  />
                </div>
              </div>
            </div>


            <div style={styles.formRow}>
              <label style={styles.label}>Name <span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                style={styles.input}
              />
            </div>


            <div style={styles.formRow}>
              <label style={styles.label}>Email <span style={{ color: "red" }}>*</span></label>
              <input
                type="email"
                name="email"
                placeholder="Enter email address"
                value={formData.email}
                onChange={handleChange}
                style={styles.input}
              />
            </div>

            <div style={styles.formRow}>
              <label style={styles.label}>Role <span style={{ color: "red" }}>*</span></label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                style={styles.input}
              >
                <option value="">Select role</option>
                {
                  subRoles.map((role, index) => (
                    <option key={index} value={role}>{role}</option>
                  ))
                }


              </select>
            </div>


            <div style={styles.formRow}>
              <label style={styles.label}>Country <span style={{ color: "red" }}>*</span></label>
              <select
                name="country"
                value={formData.country}
                onChange={handleChange}
                style={styles.input}
              >
                <option>Select country </option>
                <option>India</option>
                <option>USA</option>
              </select>
            </div>


            <div style={styles.formRow}>
              <label style={styles.label}>City <span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                name="city"
                placeholder="Enter your city"
                value={formData.city}
                onChange={handleChange}
                style={styles.input}
              />
            </div>


            <div style={styles.formRow}>
              <label style={styles.label}>Postcode <span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                name="postcode"
                placeholder="Enter your postcode"
                value={formData.postcode}
                onChange={handleChange}
                style={styles.input}
              />
            </div>

            <div style={styles.actions}>
              <button type="button" onClick={onClose} style={styles.backBtn}>
                Back
              </button>
              <button type="submit" style={styles.inviteBtn} disabled={loading}>
                {loading ? "Inviting..." : "+ Invite member"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default InviteMemberModal;


const LABEL_WIDTH = "100px";

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1300,
  },
  modal: {
    background: "#fff",
    borderRadius: "12px",
    width: "520px",
    padding: "24px",
    boxShadow: "0px 4px 16px rgba(0,0,0,0.15)",
    opacity: 0,
    transform: "translateY(-20px)",
    transition: "opacity 0.3s ease, transform 0.3s ease",
  },
  fadeIn: {
    opacity: 1,
    transform: "translateY(0)",
  },
  header: {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "20px",
    textAlign: "left",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  formRow: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  label: {
    width: LABEL_WIDTH,
    fontSize: "14px",
    color: "#333",
    textAlign: "left",
  },
  input: {
    flex: 1,
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontSize: "14px",
    outline: "none",
  },
  photoBox: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  photoContainer: {
    position: "relative",
    width: "60px",
    height: "60px",
    cursor: "pointer",
  },
  photoCircle: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    objectFit: "cover",
    background: "#f3f4f6",
  },
  removeIcon: {
    position: "absolute",
    top: "-6px",
    right: "-6px",
    fontSize: "14px",
    cursor: "pointer",
    color: "#555",
    background: "#fff",
    borderRadius: "50%",
    width: "18px",
    height: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 0 2px rgba(0,0,0,0.3)",
  },
  photoText: {
    fontSize: "13px",
    color: "#666",
    marginTop: "6px",
    textAlign: "center",
  },
  cameraCircle: {
    position: "absolute",
    bottom: "-4px",
    right: "-4px",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    background: "#1a1a40",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    zIndex: 1,
  },
  cameraOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "20px",
    borderBottomLeftRadius: "50%",
    borderBottomRightRadius: "50%",
    background: "#1a1a40",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "10px",
  },
  backBtn: {
    padding: "8px 16px",
    border: "1px solid #1a1a40",
    borderRadius: "8px",
    background: "#fff",
    cursor: "pointer",
    fontSize: "14px",
  },
  inviteBtn: {
    padding: "8px 16px",
    border: "none",
    borderRadius: "8px",
    background: "#1a1a40",
    color: "#fff",
    cursor: "pointer",
    fontSize: "14px",
  },
};
